import { DemoFrame } from './DemoFrame'
import { OverlayLogo } from './OverlayLogo'

export function Overlay() {
  return (
    <>
      <OverlayLogo />
      <DemoFrame />
    </>
  )
}
